export default __webpack_public_path__ + "static/media/LsPharmacy.fe173cb3.png";